import { Board } from '../board/Board';
import { useAuthContext } from '../../contexts/AuthContext';
import { useZoneContext } from '../../contexts/useZoneContext';

function BoardWrapper() {
    const zoneContext = useZoneContext();
    const { user } = useAuthContext();
    return <Board user={user} zoneContext={zoneContext} />;
}

export default BoardWrapper;
